<script>
import { imgPathFn } from '@/utils/common'
import { partyBuildingImgPath, getImgSrcArr } from '@/utils/filters'

export default {
  name: 'TabVertical',
  props: {
    pageData: {
      type: Array,
      default: () => []
    },
    tabActive: {
      type: Number,
      default: 0
    },
    currentDropIdx: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      path: this.$route.path,
      springback: false
    }
  },
  watch: {
    currentDropIdx(newVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          const parent = document.querySelector('.shadow-container')
          parent.scrollTo({ top: 0, behavior: 'smooth' })
        }, 200)
      })
    },
    pageData: {
      handler(newVal) {
        this.$nextTick(() => {
          setTimeout(() => {
            const parent = document.querySelector('.shadow-container')
            parent.scrollTo({ top: 0, behavior: 'smooth' })
          }, 200)
        })
      },
      deep: true
    }
    // currentDropIdx(newVal) {
    //   this.springback = true
    //   setTimeout(() => { this.springback = false }, 800)
    // }
  },
  methods: {
    imgPathFn,
    onTabClick(id) {
      this.$emit('onTabClick', id)
    },
    getImg({ img, memo }) {
      return img ? partyBuildingImgPath(img) : getImgSrcArr(memo)[0]
    }
  }
}
</script>

<template>
  <div class="tab-container">
    <div class="shadow-container">
      <!-- 'springback': springback -->
      <div
        v-for="(v, i) in pageData"
        :key="`tab-item-${i}`"
        class="tab-item pointer"
        :class="{'active-item': tabActive === i}"
        @click="onTabClick(v.id)"
      >
        <el-image class="tab-img" :src="getImg(v)" alt="acti" fit="cover" />
        <!-- imgPathFn(v.img) -->
        <div class="tab-item-right">
          <p class="h-line-1 item-title">{{ v.headline }}</p>
          <p class="item-time">{{ v.createtime | formatDate('yyyy-MM-dd') }}</p>
          <p class="h-line-2 item-memo">{{ v.memo | filtersRichtext }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  width: 415px;
  height: 590px;
  position: relative;
    &::after {
    content: '';
    position: absolute;
    height: 40px;
    width: 385px;
    left: 15px;
    bottom: 0;
    box-shadow: #fff 0px -50px 26px -28px inset;
    z-index: 2;
    border-radius: 0 0 15px 15px;
  }
  .shadow-container {
    width: 385px;
    height: 560px;
    border-radius: 15px;
    box-shadow: 0px 0px 15px 0px rgba(177,8,8,0.15);
    margin: 15px;
    background-color: #fff;
    padding: 15px 0 70px;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    overflow-y: scroll;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background: #C1C1C1;
      border-radius: 3px;
    }
    // overflow-y: scroll;
    // &::-webkit-scrollbar { // chrome/safari
    //   display: none;
    // }
    // scrollbar-width: none; // firefox
    // -ms-overflow-style: none; // IE10+
  }
  .springback {
    animation: springback ease-in-out .6s;
    animation-delay: .2;
  }
}
.tab-item {
  flex-shrink: 0;
  width: 365px;
  height: 140px;
  box-shadow: 0px 0px 10px 0px rgba(177,8,8,0.06);
  border-radius: 0 15px 15px 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  transition: all ease-in .2s;
  .tab-img {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-left: 20px;
  }
  .tab-item-right {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    margin-left: 10px;
    .item-title {
      width: 210px;
      font-size: 17px;
      font-weight: bold;
      color: #333;
    }
    .item-time {
      width: 210px;
      font-size: 13px;
      color: #999;
    }
    .item-memo {
      width: 210px;
      font-size: 15px;
      color: #333;
    }
  }
}

.active-item {
  background: #E62129;
  .tab-item-right {
    .item-title, .item-time, .item-memo {
      color: #fff;
    }
  }
}

@keyframes springback {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(40px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
